<template>
  <div>
    <el-dialog
      title="Duyệt dòng họ"
      class="dialog-choose-service-pack"
      :visible.sync="configModal.show"
      width="97%"
      top="1vh"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <p class="requied-select">Vui lòng chọn gói dịch vụ</p>
      <ServicePack
        :listPacks="listServicePacks"
        :listFunction="listChucNangs"
        :backToPrePack="backToPrePack"
        @chooseServicePack="chooseServicePack"
      />
      <div class="payment-detail">
        <div class="choose-service-pack-form">
          <el-form ref="servicePackForm" :model="dataForm" :rules="ruleForm">
            <el-row :gutter="20">
              <el-col :md="10">
                <el-form-item label="Đại lý hỗ trợ" prop="dai_ly_id">
                  <el-select
                    v-model="dataForm.dai_ly_id"
                    placeholder="Chọn đại lý"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in listAgents"
                      :key="item.id"
                      :label="item.ten"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="10">
                <el-form-item label="Đại lý khởi tạo" prop="dai_ly_khoi_tao_id">
                  <el-select
                    v-model="dataForm.dai_ly_khoi_tao_id"
                    placeholder="Chọn đại lý khởi tạo"
                    filterable
                    clearable
                    @change="changeAgentCreate"
                  >
                    <el-option
                      v-for="item in listAgents"
                      :key="item.id"
                      :label="item.ten"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="4">
                <el-form-item label="Số lượng">
                  <el-input-number
                    v-model="dataForm.so_luong"
                    controls-position="right"
                    :min="1"
                    step-strictly
                    :step="1"
                    @change="reCalculateMoney"
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :md="24">
                <el-form-item label="Voucher giảm giá" class="promotion-block">
                  <div class="list-tag-voucher">
                    <el-tag
                      v-for="tag in listMaVouchers"
                      :key="tag.ma"
                      size="large"
                      class="mx-1"
                      closable
                      :disable-transitions="false"
                      @close="handleCloseTag(tag)"
                    >
                      {{ tag.ma }}
                    </el-tag>
                  </div>
                  <div class="el-input-group-fake">
                    <input
                      v-model="promotion"
                      :class="{
                        'el-input__inner el-input__inner--fake': true,
                        is_disaled:
                          !dataForm.dai_ly_khoi_tao_id ||
                          !currentChoosedPack.id,
                      }"
                      placeholder="Nhập mã voucher"
                      :disabled="
                        !dataForm.dai_ly_khoi_tao_id || !currentChoosedPack.id
                      "
                      @keydown.enter="changeFocusButton"
                    />
                    <el-button
                      class="promotion"
                      type="primary"
                      @click="checkVoucher"
                      :disabled="!promotion"
                    >
                      Áp dụng
                    </el-button>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="choose-service-pack-detail">
          <p class="main-tit">Chi tiết thanh toán</p>
          <el-row :gutter="20">
            <el-col :md="24" class="payment-block">
              <p class="tit payment-tit">Tổng tiền</p>
              <p>
                {{ formatCurrency(payment.tongTien || 0) }}
              </p>
            </el-col>
            <el-col :md="24" class="payment-block">
              <p class="tit payment-tit">Khuyến mãi</p>
              <p>
                {{ formatCurrency(payment.giaKhuyenMai || 0) }}
                ({{
                  Math.round(
                    ((payment.giaKhuyenMai || 0) / (payment.tongTien || 1)) *
                      100 *
                      100
                  ) / 100
                }}%)
              </p>
            </el-col>
            <el-col :md="24" class="payment-block">
              <p class="tit payment-tit">Tổng tiền thanh toán</p>
              <p>
                {{ formatCurrency(payment.tongTien - payment.giaKhuyenMai) }}
              </p>
            </el-col>
          </el-row>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" plain @click="handleClose"> Hủy </el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
          :disabled="!dataForm.dai_ly_khoi_tao_id || !currentChoosedPack.id"
        >
          Duyệt
        </el-button>
      </span>
    </el-dialog>

    <!-- Dialog thông báo voucher không dùng chung -->
    <el-dialog
      :visible.sync="dialogVoucherNotSharedVisible"
      title="Thông báo"
      width="30%"
      :before-close="handleCloseDialogVoucherNotShared"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="voucher-notification-dialog"
    >
      <div class="voucher-notiffication-content">
        <p>
          Vì voucher <b>{{ vouchersNotShared.ma_voucher }}</b> không áp dụng
          chung với voucher
          <b>{{ vouchersNotShared.vouchers_khong_dung_chung.join(",") }}</b
          >. Bạn có chắc chắn muốn áp dụng voucher
          <b>{{ vouchersNotShared.ma_voucher }}</b> không? Nếu áp dụng voucher
          <b>{{ vouchersNotShared.ma_voucher }}</b> thì voucher
          <b>{{ vouchersNotShared.vouchers_khong_dung_chung.join(",") }}</b>
          không còn hiệu lực.
        </p>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="notApplicableVoucher">Thoát</el-button>
          <el-button type="primary" @click="applicableVoucher">
            Áp dụng
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- Dialog thông báo voucher không hợp lệ khi đổi gói dịch vụ hoặc đổi đại lý khởi tạo -->
    <el-dialog
      :visible.sync="dialogVoucherInvalidVisible"
      title="Thông báo"
      width="30%"
      :before-close="handleCloseDialogInvalidNotShared"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <p>
          {{ messageVoucherInvallidAfterCheck }}
        </p>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="notApplicableVoucherForChange">Thoát</el-button>
          <el-button type="primary" @click="applicableVoucherForChange">
            Đồng ý
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import mushroom from "viettoc-api";
import MethodService from "@/service/MethodService";
import ValidService from "../../../service/ValidService";
import ServicePack from "@/component/ServicePack";
import { async } from "q";

export default {
  props: ["configModal", "dataDanhKyDongHo"],
  components: {
    ServicePack,
  },
  data() {
    return {
      listServicePacks: [],
      listAgents: [],
      dataForm: {
        dang_ky_id: undefined,
        goi_dich_vu_id: undefined,
        dai_ly_id: undefined,
        dai_ly_khoi_tao_id: undefined,
        vouchers: undefined,
        so_luong: 1,
      },
      ruleForm: {
        dai_ly_id: [ValidService.requiredChange],
        dai_ly_khoi_tao_id: [ValidService.requiredChange],
      },
      payment: {
        tongTien: 0,
        giaKhuyenMai: 0,
      },
      currentChoosedPack: {},
      listMaVouchers: [],
      listChucNangs: [],
      listVoucherInvalids: [],
      promotion: undefined,
      vouchersNotShared: {
        ma_voucher: undefined,
        vouchers_khong_dung_chung: [],
      },
      dialogVoucherNotSharedVisible: false,
      dialogVoucherInvalidVisible: false,
      voucherInvalidsAfterCheck: [],
      messageVoucherInvallidAfterCheck: undefined,
      beforeServicePack: undefined,
      beforeAgent: undefined,
      backToPrePack: undefined,
    };
  },
  methods: {
    async getAllAgent() {
      if (!this.dataDanhKyDongHo) return;
      try {
        let arrDaiLyIds = [];
        const cauHinhHeThongRes = await mushroom.cau_hinh_he_thong.listAsync({
          filters: `ten=dai_ly_viet_toc_id`,
          fields: "id,ghi_chu,gia_tri",
        });
        if (this.dataDanhKyDongHo.tinh_id) {
          const agtDaiLyTinhRes = await mushroom.agt_dai_ly_tinh.getAllAsync({
            filters: `tinh_id=${this.dataDanhKyDongHo.tinh_id}`,
            fields: "dai_ly_id,tinh_id",
          });
          arrDaiLyIds = agtDaiLyTinhRes.result.map((x) => x.dai_ly_id);
        } else {
          arrDaiLyIds = [cauHinhHeThongRes.result[0].gia_tri];
        }
        const agtDaiLyRes = await mushroom.agt_dai_ly.getAllAsync({
          filters: `id:in:${arrDaiLyIds.join(",")}`,
          fields: "id,ten",
        });
        this.listAgents = agtDaiLyRes.result;
        this.dataForm.dai_ly_id = cauHinhHeThongRes.result[0].gia_tri;
        this.dataForm.dai_ly_khoi_tao_id = cauHinhHeThongRes.result[0].gia_tri;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async load() {
      try {
        const prdSanPhamRes = await mushroom.prd_san_pham.getAllAsync({
          filters: "loai=khoi_tao&hieu_luc=true",
        });
        const arrGoiDichVuIds = MethodService.findListItemDifferent(
          prdSanPhamRes.result,
          "goi_dich_vu_id"
        );
        const pmsChucNangRes = await mushroom.pms_chuc_nang.getAllAsync({
          fields: "ma,tuy_bien_hien_thi,don_vi",
        });
        const prdGoiDichVuRes = await mushroom.prd_goi_dich_vu.listAsync({
          filters: `id:in:${arrGoiDichVuIds.join(",")}`,
          limit: arrGoiDichVuIds.length,
        });
        this.listChucNangs = pmsChucNangRes.result;
        this.listServicePacks = prdGoiDichVuRes.result;
        this.listServicePacks.forEach((e) => {
          e.gia_niem_yet = prdSanPhamRes.result.find(
            (x) => x.goi_dich_vu_id === e.id
          ).gia_niem_yet;
          const sanPhamItem = prdSanPhamRes.result.filter(
            (x) => x.goi_dich_vu_id === e.id
          );
          e.san_pham_ids = (sanPhamItem || []).map((x) => x.id);
        });
        this.listServicePacks = this.listServicePacks.sort(
          (a, b) => a.gia_niem_yet - b.gia_niem_yet
        );
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    chooseServicePack(pack) {
      this.beforeServicePack = MethodService.copyObject(
        this.currentChoosedPack
      );
      setTimeout(() => {
        this.currentChoosedPack = pack;
        this.payment.tongTien = pack.gia_niem_yet * this.dataForm.so_luong;
        this.checkVoucherValidWhenChangeAgnetOrServicepack("changeServicePack");
        this.coutPromotion();
      }, 100);
    },
    changeAgentCreate() {
      if (!this.dataForm.dai_ly_khoi_tao_id) {
        this.promotion = undefined;
        this.listMaVouchers = [];
        return;
      }
      this.checkVoucherValidWhenChangeAgnetOrServicepack("changeAgentCreate");
    },
    coutPromotion() {
      let totalDiscount = 0;
      this.listMaVouchers.forEach((e) => {
        if (e.kieu_gia_tri === "pct") {
          totalDiscount +=
            (this.payment.tongTien * this.dataForm.so_luong * e.gia_tri) / 100;
        } else if (e.kieu_gia_tri === "vnd") {
          totalDiscount += e.gia_tri;
        }
      });
      this.payment.giaKhuyenMai =
        totalDiscount > this.payment.tongTien * this.dataForm.so_luong
          ? this.payment.tongTien
          : totalDiscount;
    },
    notApplicableVoucher() {
      this.promotion = undefined;
      this.handleCloseDialogVoucherNotShared();
    },
    applicableVoucher() {
      this.listMaVouchers = this.listMaVouchers.filter(
        (x) => !this.vouchersNotShared.vouchers_khong_dung_chung.includes(x.ma)
      );
      this.pushPromition(this.vouchersNotShared);
      this.handleCloseDialogVoucherNotShared();
    },
    notApplicableVoucherForChange() {
      this.promotion = undefined;
      this.backToPrePack = this.beforeServicePack;
      this.currentChoosedPack = this.beforeServicePack;
      this.payment.tongTien =
        this.currentChoosedPack.gia_niem_yet * this.dataForm.so_luong;
      this.coutPromotion();
      this.handleCloseDialogInvalidNotShared();
    },
    applicableVoucherForChange() {
      this.listMaVouchers = this.listMaVouchers.filter(
        (x) => !this.listVoucherInvalids.includes(x.ma)
      );
      this.coutPromotion();
      this.handleCloseDialogInvalidNotShared();
    },
    pushPromition(checkVouccherRes) {
      const data = {
        ma: this.promotion,
        gia_tri: checkVouccherRes.gia_tri,
        kieu_gia_tri: checkVouccherRes.kieu_gia_tri,
      };
      this.listMaVouchers.push(data);
      this.promotion = undefined;
      this.coutPromotion();
    },
    reCalculateMoney() {
      this.payment.tongTien =
        this.currentChoosedPack.gia_niem_yet * this.dataForm.so_luong;
      this.coutPromotion();
    },
    checkVoucherExist() {
      const haveVoucher = this.listMaVouchers.find(
        (x) => x.ma === this.promotion
      );
      return haveVoucher;
    },
    async checkVoucher() {
      try {
        if (this.checkVoucherExist()) {
          window.toastr.info(`Voucher "${this.promotion}" đã được sử dụng!`);
          return;
        }
        const checkVouccherRes =
          await mushroom.ord_don_hang.kiem_tra_vouchersAsync({
            body: {
              ma_vouchers: this.listMaVouchers.map((x) => x.ma),
              ma_voucher_kiem_tra: this.promotion,
              dai_ly_id: this.dataForm.dai_ly_khoi_tao_id,
              san_pham_ids: this.currentChoosedPack.san_pham_ids,
            },
          });
        if (!checkVouccherRes.result) return;
        if (
          !checkVouccherRes.result.hop_le ||
          !checkVouccherRes.result.san_pham_ids_hop_le ||
          checkVouccherRes.result.san_pham_ids_hop_le.length === 0
        ) {
          window.toastr.info(`Voucher "${this.promotion}" không hợp lệ`);
          this.promotion = undefined;
          return;
        }
        if (
          checkVouccherRes.result.vouchers_khong_dung_chung &&
          checkVouccherRes.result.vouchers_khong_dung_chung.length > 0
        ) {
          this.vouchersNotShared = checkVouccherRes.result;
          this.vouchersNotShared.vouchers_khong_dung_chung =
            checkVouccherRes.result.vouchers_khong_dung_chung;
          this.vouchersNotShared.ma_voucher = this.promotion;
          this.dialogVoucherNotSharedVisible = true;
          return;
        }
        this.pushPromition(checkVouccherRes.result);
      } catch (error) {
        console.error("Có lỗi: %o", error);
      }
    },
    async checkVoucherValidWhenChangeAgnetOrServicepack(type) {
      let listVoucherValids = [];
      let listVoucherInvalids = [];
      for (const item of this.listMaVouchers) {
        const res = await this.checkValidVoucher(item, listVoucherValids);
        if (res.result.hop_le && res.result.san_pham_ids_hop_le.length > 0)
          listVoucherValids.push(item.ma);
        else listVoucherInvalids.push(item.ma);
      }
      if (listVoucherInvalids.length > 0) {
        this.showDialogInvalidVoucher(listVoucherInvalids, type);
        this.listVoucherInvalids = listVoucherInvalids;
      }
    },
    async checkValidVoucher(item, listVoucherValids) {
      return mushroom.ord_don_hang.kiem_tra_vouchersAsync({
        body: {
          ma_vouchers: listVoucherValids,
          ma_voucher_kiem_tra: item.ma,
          dai_ly_id: this.dataForm.dai_ly_khoi_tao_id,
          san_pham_ids: this.currentChoosedPack.san_pham_ids,
        },
      });
    },
    changeFocusButton() {
      if (!this.promotion) return;
      this.checkVoucher();
    },
    // Open dialog
    showDialogInvalidVoucher(listVoucherInvalids, type) {
      this.messageVoucherInvallidAfterCheck = `Vì ${
        listVoucherInvalids.length > 1 ? "các" : ""
      } voucher ${listVoucherInvalids.join(", ")} không áp dụng đối với ${
        type === "changeServicePack" ? "gói" : "đại lý"
      } ${
        type === "changeServicePack" ? this.getNamePack() : this.getNameAgent()
      }. Bạn có chắc chắn muốn thay đổi ${
        type === "changeServicePack" ? "gói" : "đại lý"
      }? Nếu thay đổi  ${type === "changeServicePack" ? "gói" : "đại lý"} thì ${
        listVoucherInvalids.length > 1 ? "các" : ""
      } voucher ${listVoucherInvalids.join(", ")} không còn hiệu lực!`;
      this.dialogVoucherInvalidVisible = true;
    },
    getNamePack() {
      return this.currentChoosedPack.ten;
    },
    getNameAgent() {
      const daiLy = this.listAgents.find(
        (e) => e.id === this.dataForm.dai_ly_khoi_tao_id
      );
      return daiLy.ten;
    },
    // Close dialog
    handleClose() {
      this.$emit("close");
    },
    handleSubmit() {
      if (!this.currentChoosedPack.id) {
        window.toastr.warning(`Vui lòng chọn gói dịch vụ!`);
        return;
      }
      this.$refs["servicePackForm"].validate((valid) => {
        if (!valid) return false;
        const dataApply = {
          dang_ky_id: this.$router.currentRoute.params.id,
          goi_dich_vu_id: this.currentChoosedPack.id,
          dai_ly_id: this.dataForm.dai_ly_id,
          dai_ly_khoi_tao_id: this.dataForm.dai_ly_khoi_tao_id,
          vouchers: this.listMaVouchers.map((x) => x.ma),
          so_luong: this.dataForm.so_luong,
        };
        this.$emit("submit", { dataApply });
      });
    },
    handleCloseTag(tag) {
      this.listMaVouchers = this.listMaVouchers.filter(
        (item) => item.ma !== tag.ma
      );
      this.coutPromotion();
    },
    handleCloseDialogVoucherNotShared() {
      this.dialogVoucherNotSharedVisible = false;
      setTimeout(() => {
        this.vouchersNotShared = {
          ma_voucher: undefined,
          vouchers_khong_dung_chung: [],
        };
      }, 1000);
    },
    handleCloseDialogInvalidNotShared() {
      this.dialogVoucherInvalidVisible = false;
    },
    // Format function
    formatCurrency(value) {
      if (value === undefined) return;
      return MethodService.formatCurrencyVND(value);
    },
  },
  created() {
    this.getAllAgent();
    this.load();
  },
  watch: {
    dataDanhKyDongHo: function () {
      this.getAllAgent();
    },
  },
};
</script>
<style lang="scss">
.el-dialog__body {
  word-break: break-word;
}
.dialog-choose-service-pack {
  .el-dialog {
    margin-bottom: 0;
    &__body {
      padding-bottom: 0;
      max-height: calc(100vh - 110px);
      overflow-y: auto;
      .requied-select::after {
        content: "*";
        color: #fa4949;
        margin-left: 4px;
        font-weight: 700;
      }
      .service-pack-component {
        margin-bottom: 10px;
        max-height: calc(100vh - 330px);
        overflow-y: auto;
        overflow-x: hidden;
      }
      .payment-detail {
        display: flex;
        justify-content: space-between;
        .choose-service-pack-form {
          width: 100%;
          margin-right: 10px;
          padding-right: 10px;
          border-right: 1px dashed #9ba4b5;
          .promotion-block {
            .el-form-item__label {
              display: contents;
            }
            .el-form-item__content {
              display: flex;
              .list-tag-voucher {
                display: flex;
                flex-wrap: wrap;
              }
              .el-input-group-fake {
                display: flex;
                min-width: 230px;
                flex: 1 1;
                .el-input__inner--fake {
                  height: 32px;
                  line-height: 32px;
                  border-top-right-radius: 0;
                  border-bottom-right-radius: 0;
                  &.is_disaled {
                    background-color: #f5f7fa;
                    border-color: #e4e7ed;
                    color: #c0c4cc;
                    cursor: not-allowed;
                  }
                }
              }
              .promotion.el-button {
                height: 32px;
                background-color: #409eff !important;
                border-color: #409eff !important;
                color: #fff !important;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
              }
            }
          }
        }
        .choose-service-pack-detail {
          width: 340px;
          .main-tit {
            color: #282828;
            margin-bottom: 15px;
            font-size: 1.275rem;
            font-weight: 600;
          }
          .payment-block {
            display: flex;
            margin-bottom: 22px;
            &:last-child {
              margin-bottom: 0;
            }
            .payment-tit {
              width: 140px;
            }
          }
        }
      }
      .el-form-item--small.el-form-item {
        margin-bottom: 16px;
      }
    }
    &__footer {
      padding: 10px 20px 15px;
    }
  }
}
</style>
